import { replaceTextInRichText } from "@jog/shared"
import { JoggCart } from "@jog/types"
import { RTParagraphNode, RichTextField } from "@prismicio/types"
import { useMemo } from "react"

import { useI18n } from "./useI18n"

const handleText = (formerText: RichTextField, latterText: RichTextField) => {
    const sizeNode = formerText?.[0] as RTParagraphNode
    const toolNode = latterText?.[0] as RTParagraphNode
    const spans = toolNode.spans.map((span) => {
        return {
            type: span.type,
            start: span.start + sizeNode.text.length,
            end: span.end + sizeNode.text.length,
        }
    })
    return [
        {
            ...toolNode,
            text: sizeNode.text + toolNode.text,
            spans: [...sizeNode.spans, ...spans],
        },
    ] as RichTextField
}
export const useSizeConflictText = (
    cartItems: JoggCart["lineItems"],
    ctpId: string,
    rawText: RichTextField,
    rawToolRecommendText: RichTextField,
    rawOwnSizeRecommendText: RichTextField,
    sku: string
) => {
    const { $t } = useI18n()
    const currentSizesInCart = useMemo(
        () =>
            cartItems
                ?.filter((lineItem) => lineItem?.productId === ctpId)
                .map((item) => (item.length ? `${item.size}/${item.length}` : item.size)) || [],
        [cartItems, ctpId]
    )
    const currentSkuInCart = useMemo(
        () => cartItems?.filter((lineItem) => lineItem?.productId === ctpId).map((item) => item.sku) || [],
        [cartItems, ctpId]
    )
    const sizeConflictText = useMemo(() => {
        const replacedText =
            currentSizesInCart.length > 2
                ? [currentSizesInCart.slice(0, -1).join(", "), ...currentSizesInCart.slice(-1)].join(" and ")
                : currentSizesInCart.join(` ${$t("and")} `)
        return replaceTextInRichText(rawText, "{X}", replacedText)
    }, [$t, currentSizesInCart, rawText])

    const toolRecommendText = useMemo(
        () => handleText(sizeConflictText, rawToolRecommendText),
        [rawToolRecommendText, sizeConflictText]
    )
    const ownSizeRecommendText = useMemo(
        () => handleText(sizeConflictText, rawOwnSizeRecommendText || rawToolRecommendText),
        [rawOwnSizeRecommendText, rawToolRecommendText, sizeConflictText]
    )
    const isShowSizeAlert = useMemo(
        () => sku && currentSkuInCart.length && !currentSkuInCart.includes(sku) && sizeConflictText,
        [currentSkuInCart, sizeConflictText, sku]
    )
    return {
        isShowSizeAlert,
        toolRecommendText,
        ownSizeRecommendText,
    }
}
